var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "engagement_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#engagement_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.394 19.492a6.836 6.836 0 10-6.836-6.836 6.835 6.835 0 006.836 6.836zm0 1.303a8.14 8.14 0 100-16.278 8.14 8.14 0 000 16.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.83.093a.328.328 0 01.553.192l.235 1.888.51-.499a.497.497 0 01.696.005l.737.737c.19.19.189.498-.004.686l-.481.47 1.639.203c.266.033.38.36.192.554l-4.155 4.295a.321.321 0 01-.232.098h-2.725l-3.79 3.698a1.628 1.628 0 11-1.472-1.386l3.903-3.806v-2.75c0-.086.035-.17.098-.23L19.83.093z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.76 10.469l-.992.991a3.58 3.58 0 01-3.375 4.776l-.001.001a3.581 3.581 0 111.151-6.974l1.011-.988a4.884 4.884 0 102.206 2.194zm-1.696-1.902l-.968.938a3.594 3.594 0 011.436 1.428l.958-.936a4.92 4.92 0 00-1.426-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.61 7.605l-.983.972a10.06 10.06 0 01.859 4.08c0 5.573-4.518 10.091-10.092 10.091-5.574 0-10.092-4.518-10.092-10.091 0-5.574 4.518-10.092 10.092-10.092 1.456 0 2.84.308 4.089.863l.986-.975a11.338 11.338 0 00-5.075-1.19C5.101 1.263 0 6.363 0 12.657 0 18.949 5.101 24.05 11.394 24.05v.001c6.293 0 11.394-5.102 11.394-11.394 0-1.814-.424-3.529-1.178-5.052zm-4.541-4.831l-.965.955a10.145 10.145 0 014.223 4.228l.963-.952a11.453 11.453 0 00-4.221-4.231z"
  }))));
}
export default SvgEngagement;